module.exports = __webpack_public_path__ + "static/media/dentista.4b709c12.png";